<table class="user-permit-tbl" *ngIf="loaded">
    <caption></caption>
    <thead>
        <tr>
            <th>
            </th>
            <th *ngFor="let role of tableValues.roles">
                {{role.key}}
            </th>
        </tr>
    </thead>
  <tbody>
    <tr *ngFor="let permit of tableValues.permits">
        <td>
            {{permit.key}}
        </td>
        <td *ngFor="let role of tableValues.roles">  
            <mat-checkbox class="example-margin" (change)="checkBoxChanged($event,role.id,permit.id)" [checked]="validatePermit(role,permit)"></mat-checkbox> 
        </td>
    </tr>
  </tbody>
 
</table>